<div>
  <div class="flex flex-wrap gap-1.5 mb-2">
    @for (nombre of banco; track nombre) {
      <span class="relative inline-flex">
        <button type="button" (click)="alternar(nombre)" [class]="claseChip(nombre)">
          {{ nombre }}
        </button>
        @if (muestraX(nombre)) {
          <button
            type="button"
            (click)="eliminarDelBanco($event, nombre)"
            [attr.aria-label]="'Eliminar ' + nombre + ' del banco'"
            class="absolute -top-1.5 -left-1.5 w-4 h-4 rounded-full text-white text-[10px] leading-none flex items-center justify-center"
            style="background: var(--coral)"
          >
            ×
          </button>
        }
      </span>
    }
  </div>
  @if (onAgregarAlBanco) {
    <div class="flex gap-1.5">
      <label [attr.for]="inputId" class="sr-only">Agregar valor al banco</label>
      <input
        [id]="inputId"
        [ngModel]="nuevo()"
        (ngModelChange)="nuevo.set($event)"
        (keydown)="alPresionarTecla($event)"
        placeholder="+ nuevo…"
        class="flex-1 border border-dashed border-[var(--faint)] rounded-full px-3 py-1.5 text-[12px] bg-[var(--surface)]"
      />
      <button type="button" (click)="agregarNuevo()" class="text-[12px] font-semibold px-3 py-1.5 rounded-full border border-[var(--border)] bg-[var(--surface)]">
        Agregar
      </button>
    </div>
  }
</div>
